export const fallbackSystemDateFormat = (date) => new Date(date).toLocaleString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
});
//# sourceMappingURL=format.util.js.map